import React from 'react';
import { FileText, BookOpen, Pencil, Mail, Paperclip, StickyNote, Calculator, GraduationCap, Briefcase, Phone } from 'lucide-react';
import { Button } from './ui/button';
import { Card, CardContent } from './ui/card';

const Papelaria = () => {
  const items = [
    { name: "Papel A4", icon: FileText },
    { name: "Cadernos", icon: BookOpen },
    { name: "Canetas e Lápis", icon: Pencil },
    { name: "Pastas", icon: Mail },
    { name: "Envelopes", icon: Mail },
    { name: "Grampeadores e Clips", icon: Paperclip },
    { name: "Blocos de Notas", icon: StickyNote },
    { name: "Calculadoras", icon: Calculator },
    { name: "Materiais Escolares", icon: GraduationCap },
    { name: "Materiais para Escritório", icon: Briefcase }
  ];

  const whatsappNumber = "5585985195369";
  const whatsappMessage = "Olá! Gostaria de um orçamento de materiais de papelaria.";
  const whatsappLink = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(whatsappMessage)}`;

  return (
    <section id="papelaria" className="py-20 bg-gradient-to-b from-gray-50 to-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <div className="inline-block mb-4 px-4 py-2 bg-[#f97316]/10 rounded-full">
            <p className="text-[#f97316] text-sm font-semibold">PAPELARIA</p>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Papelaria em Fortaleza
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Além dos serviços gráficos, a <span className="font-semibold text-[#1e3a8a]">Infortech</span> também oferece uma linha completa de <span className="font-semibold">materiais de papelaria e escritório</span> para estudantes, empresas e profissionais em Fortaleza.
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4 mb-12">
          {items.map((item, index) => {
            const IconComponent = item.icon;
            return (
              <Card key={index} className="hover:shadow-lg transition-all hover:-translate-y-1">
                <CardContent className="p-6 text-center">
                  <div className="w-14 h-14 bg-gradient-to-br from-[#f97316]/10 to-[#fb923c]/10 rounded-lg flex items-center justify-center mx-auto mb-3">
                    <IconComponent className="w-7 h-7 text-[#f97316]" />
                  </div>
                  <p className="text-sm font-semibold text-gray-900">{item.name}</p>
                </CardContent>
              </Card>
            );
          })}
        </div>

        <div className="text-center">
          <Button
            onClick={() => window.open(whatsappLink, '_blank')}
            size="lg"
            className="bg-[#25D366] hover:bg-[#20BD5C] text-white font-semibold px-8 shadow-lg hover:shadow-xl transition-all"
          >
            <Phone className="w-5 h-5 mr-2" />
            Solicitar Orçamento pelo WhatsApp
          </Button>
        </div>
      </div>
    </section>
  );
};

export default Papelaria;
